const pensionPortfolioDebugStore = reactive({
  mockCategories: false,
})

export function usePensionPortfolioDebug() {
  return {
    debugStore: pensionPortfolioDebugStore,
  }
}
